import { MODULES, SHORT_CODE_LENGTH } from '@/constants'

export default [
  {
    path: `/:id([A-z0-9]{${SHORT_CODE_LENGTH}})`,
    name: 'fusebox.preview',
    meta: {
      title: 'general.fuseboxes',
      public: true
    },
    component: () => import('@/views/Fusebox/_Id/Index.vue')
  },
  {
    path: '/fusebox',
    meta: {
      title: 'general.fuseboxes',
      requiresAuth: true,
      permission: MODULES.FUSEBOX
    },
    children: [
      {
        path: '/',
        name: 'fusebox.index',
        meta: {
          title: 'general.fuseboxes'
        },
        component: () => import('@/views/Fusebox/Index.vue')
      },
      {
        path: ':id',
        children: [
          {
            path: '/',
            name: 'fusebox.single.index',
            meta: {
              title: 'general.fuseboxes'
            },

            component: () => import('@/views/Fusebox/_Id/Index.vue')
          }
        ],
        component: () => import('@/views/Fusebox/_Id.vue')
      }
    ],
    component: () => import(`@/views/Fusebox.vue`)
  }
]
